<template>
  <div style="height: 300px;">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';

export default {
  name: 'BarChartWrapper',
  extends: Bar,
  props: {
    regionWiseTalents: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
  regionWiseTalents: {
    handler(newData) {
      if (!Array.isArray(newData)) return;

      // 🧹 Clean & map API data
      const cleanedData = newData
        .filter(item => item.nationality && item.totalTalents != null)
        .map(item => ({
          nationality: item.nationality.trim(),
          totalTalents: Number(item.totalTalents),
        }));

      // 🧪 Debug (can remove later)
      console.log('Nationality Wise Talents:', cleanedData);

      // 🎨 Render Bar Chart
      this.renderChart(
        {
          labels: cleanedData.map(item => item.nationality),
          datasets: [
            {
              label: 'Total Talents',
              backgroundColor: '#42A5F5',
              borderRadius: 6,
              data: cleanedData.map(item => item.totalTalents),
              barPercentage: 0.6,
              categoryPercentage: 0.6,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  stepSize: 1,
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  autoSkip: false,
                  maxRotation: 45,
                  minRotation: 45,
                },
              },
            ],
          },
        }
      );
    },
    immediate: true,
    deep: true,
  },
},

};
</script>

<style scoped>
/* Container height set inline in template */
/* You can also add additional styles if needed */
</style>
